import React from 'react';
import './index.less';
import { MessageHeaderProps } from '@/types/message';



const prefix = 'message-header';
const MessageHeader: React.FC<MessageHeaderProps> = (props) => {
  const { title="",des,LeftSolt } = props;
  return (
    <div className='message-header'>
      {LeftSolt && <div className={`${prefix}-left`}>
              {LeftSolt}
        </div>}
      <div className={`${prefix}-title`}>{title}</div>
      {des && <div className={`${prefix}-des`}>{des}</div>}
    </div>
  );
};

export default React.memo(MessageHeader);
